import { render } from "./AiDialog.vue?vue&type=template&id=4840c882&scoped=true"
import script from "./AiDialog.vue?vue&type=script&lang=js"
export * from "./AiDialog.vue?vue&type=script&lang=js"

import "./AiDialog.vue?vue&type=style&index=0&id=4840c882&scoped=true&lang=css"

import exportComponent from "/root/esg_nexus/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4840c882"]])

export default __exports__